import styled from 'styled-components';

export const FreeEcomSiteContainer = styled.div`
    width: 100vw;
    height: 100vh; /* Just for demonstration, adjust as needed */
    max-height: 100vh;
    overflow-y: auto;

    .content-contact-box {
        width: 100%;
        display: flex;
    }
`;